import { Stack, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import React from 'react'
import { GridLogicOperator, gridFilterModelSelector, useGridApiContext } from '@mui/x-data-grid-pro';
import { Clear } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { IRootState } from '../../store/reducer';

const QuickFilterToolbar = ({reverse, showShowdownPositions}: { reverse: boolean, showShowdownPositions: boolean}) => {
  const [selected, setSelected] = React.useState<string>('')
  const [search, setSearch] = React.useState<string>('')
  const apiRef = useGridApiContext();
  const currentFilterModel = gridFilterModelSelector(apiRef);
  const { selectedSlate } = useSelector((state: IRootState) => state.common);
  const lineupPositions = selectedSlate.lineupRules.positions.split(',').map((position: string) => position.trim());

  const positions = [
   ...Array.from(new Set(lineupPositions))
  ];
  
  const onSearch = (search: string) => {
    apiRef.current.setFilterModel({
      items: [
        ...currentFilterModel.items.filter((item) => item.field !== 'name').filter((item) => item.field !== 'player'),
        { field: 'name', operator: 'contains', value: search,  },
        { field: 'player', operator: 'contains', value: search },
      ]
    })
    setSearch(search);
  }

  const onSelect = (newSelection: string) => {
    apiRef.current.setFilterModel({
      logicOperator: GridLogicOperator.And,
      items: [
        ...currentFilterModel.items.filter((item) => item.field !== 'canBeAddedToPositions'),
        ...newSelection && newSelection !== selected ? [{ field: 'canBeAddedToPositions', operator: 'has', value: newSelection }] : []
      ],
    })

      setSelected(newSelection !== selected ? newSelection : '');
  }

  React.useEffect(() => {
    if(currentFilterModel.items.find((item) => item.field === 'canBeAddedToPositions')) {
      const currentFilter = currentFilterModel.items.find((item) => item.field === 'canBeAddedToPositions');

      setSelected(Array.isArray(currentFilter?.value || '') ? currentFilter?.value.join(',') : currentFilter?.value || '');
    }
  }, [])

  return (
    <Stack direction={reverse ? 'row-reverse' :'row'} alignItems='center' columnGap={2}>
      <TextField
        variant='outlined'
        placeholder='Search Players'
        InputProps={{
          startAdornment: <SearchIcon />,
          endAdornment: search && <Clear sx={{ cursor: 'pointer' }} onClick={() => onSearch('')}/>
        }}
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        sx={{
          border: '1px solid rgba(255, 255, 255, 0.15)',
          borderRadius: '6px',
          color: 'white',
          '& .MuiInputBase-root': {
            paddingLeft: '8px',
          },
          '& input': {
            color: 'white',
            padding: 0,
            paddingLeft: '8px',
            height: '32px',
          }
        }}
      />
      <Stack direction='row' columnGap={2.5}>
        {
          positions.map((position) => (
            <Stack key={position} fontSize='12px' fontWeight={500} padding='8px' onClick={() => onSelect(position)} sx={{ cursor: 'pointer', ...(selected === position && { backgroundColor: '#015ACE', borderRadius: '6px', }) }}>{position}</Stack>
          ))
        }
        <Stack fontSize='12px' fontWeight={500} padding='8px' onClick={() => onSelect('')} sx={{ cursor: 'pointer', ...(!selected && { backgroundColor: '#015ACE', borderRadius: '6px', }) }}>ALL</Stack>
      </Stack>
    </Stack>
  )
}

export default QuickFilterToolbar